import { IInvoice } from "interfaces/entities/invoice";
import { ISetInvoicesDataPayload } from "store/entities/invoices/interfaces";
import { IActionWithPayload } from "store/helper";
import { InvoicesViewAction, InvoicesViewActionsNames } from "store/views/invoices/actions";

export interface IInvoicesViewState {
  data: IInvoice[];
}

export const initialState: IInvoicesViewState = {
  data: [],
};

export const invoicesViewReducer = (
  state: IInvoicesViewState = initialState,
  action: InvoicesViewAction
): IInvoicesViewState => {
  switch (action.type) {
    case InvoicesViewActionsNames.SET_INVOICES_VIEW_DATA: {
      const { payload } = action as IActionWithPayload<string, ISetInvoicesDataPayload>;

      return {
        ...state,
        data: payload.data,
      };
    }

    default:
      return state;
  }
};
